<template>
  <div class="animated fadeIn">
    <v-dialog v-model="changeLogo" max-width="600px" persistent>
      <v-card class="profile-modalCard">
        <v-card-title class="c-primary">افزودن لوگو</v-card-title>
        <br />
        <v-card-text>
          <h5 class="mb-8 text-center">
            آیا میخواهید برای شتاب‌دهنده لوگو اضافه کنید ؟
          </h5>

          <v-row class="justify-content-center mb-2 mt-1">
            <v-btn
              @click="
                addImage = true;
                uploading = false;
              "
              :loading="fileBusy"
              color="primary"
              >ثبت لوگو</v-btn
            >
            <v-btn
              color="red"
              @click="notChangeLogo()"
              class="text-light ml-2 me-2 ms-2"
              >بعدا بارگذاری شود</v-btn
            >
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addImage" width="450">
      <v-card class="modal-card">
        <v-container class="p-4">
          <v-row class="mb-1">
            <v-col class="text-right">
              <h5 class="mt-1 c-dark fs-xlarge">افزودن لوگو</h5>
            </v-col>
            <v-col cols="2" class="text-left">
              <span @click="addImage = false">
                <v-icon class="pointer">mdi-close</v-icon>
              </span>
            </v-col>
          </v-row>
          <div v-if="!uploading">
            <div
              class="upload-box"
              @dragover="dragover"
              @dragleave="dragleave"
              @drop="drop"
            >
              <p class="c-grey fs-large mb-2">
                فایل مورد نظر را به این قسمت بکشید
              </p>

              <p class="c-grey fs-large mb-2">یا</p>
              <v-btn
                @click="$refs.upload.$refs.input.click()"
                class="c-primary b-primary bc-white"
                elevation="0"
                height="42"
                >یافتن فایل</v-btn
              >
            </div>
          </div>
          <div v-else>
            <div class="d-flex flex-row w-100">
              <div class="file-icon">
                <v-icon large>$File</v-icon>
              </div>
              <div class="w-100 px-3">
                <p class="mb-0">در حال بارگذاری تصویر...</p>
                <v-progress-linear
                  class="mt-1"
                  outlined
                  height="4"
                  :value="myFile.uploadPercentage"
                  color="#068D9D"
                >
                </v-progress-linear>
              </div>
              <div class="c-primary pt-4">{{ myFile.uploadPercentage }}%</div>
            </div>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
    <v-file-input
      @change="myUpload(file)"
      v-model="file"
      ref="upload"
      outlined
      dense
      v-show="false"
    ></v-file-input>

    <b-card
      v-if="$router.currentRoute.path == '/admin/addAccelerator'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <h2>افزودن شتاب‌دهنده جدید</h2>
      <hr />
      <b-row>
        <b-col cols="12" sm="12" md="12" lg="12" class="">
          <b-form-group
            label="نام شتاب‌دهنده"
            :class="newAccelerator.name ? 'done' : 'required'"
          >
            <b-form-input
              trim
              v-model="newAccelerator.name"
              type="text"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="نام کاربری (به زبان انگلیسی وارد کنید.)"
            :class="
              newAccelerator.username && computedUsername ? 'done' : 'required'
            "
          >
            <b-form-input
              trim
              v-model="newAccelerator.username"
              @keydown="justEng($event)"
              type="text"
            ></b-form-input>
            <span
              class="text-danger"
              v-if="newAccelerator.username && !computedUsername"
              >* استفاده از حروف الزامی است!</span
            >
          </b-form-group>
          <b-form-group
            label="شماره همراه"
            :class="newAccelerator.mobile ? 'done' : 'required'"
          >
            <b-form-input
              trim
              v-model="newAccelerator.mobile"
              type="number"
              :no-wheel="true"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="تلفن‌های تماس">
            <b-form-input
              trim
              v-model="newAccelerator.tel"
              :no-wheel="true"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group label="ایمیل">
        <b-form-input
          trim
          v-model="newAccelerator.email"
          type="email"
          :state="validateEmail(newAccelerator.email) ? null : false"
          aria-describedby="email"
        ></b-form-input>
        <b-form-invalid-feedback id="email"
          >پست الکترونیک صحیح نیست</b-form-invalid-feedback
        >
      </b-form-group>
      <b-form-group label="آدرس تارنما">
        <b-form-input
          trim
          v-model="newAccelerator.website"
          :state="checkUrl(newAccelerator.website) ? null : false"
          type="url"
        ></b-form-input>
        <b-form-invalid-feedback id="url"
          >آدرس تارنما صحیح نیست</b-form-invalid-feedback
        >
      </b-form-group>
      <b-form-group label="مدیر عامل">
        <b-form-input
          trim
          v-model="newAccelerator.ceoName"
          type="text"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label="شماره ثبت"
        :class="newAccelerator.registrationNumber ? 'done' : 'required'"
      >
        <b-form-input
          trim
          v-model="newAccelerator.registrationNumber"
          type="number"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label="شناسه ملی"
        :class="newAccelerator.nationalId ? 'done' : 'required'"
      >
        <b-form-input
          trim
          v-model="newAccelerator.nationalId"
          type="number"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="کد اقتصادی">
        <b-form-input
          trim
          v-model="newAccelerator.economicCode"
          type="number"
        ></b-form-input>
      </b-form-group>
      <div class="d-flex flex-row my-5">
        <b-form-checkbox v-model="newAccelerator.isTrusted"></b-form-checkbox>
        <span class="ps-2"> شتاب‌دهنده معتمد می‌باشد. </span>
      </div>
      <b-form-group
        description
        label="استان"
        :class="newAccelerator.stateId ? 'done' : 'required'"
      >
        <v-autocomplete
          v-model="newAccelerator.stateId"
          :items="iran"
          @change="newAccelerator.cityId = ''"
          item-value="id"
          item-text="name"
          dense
          outlined
          class="dropdown-style"
          hide-details
        ></v-autocomplete>
      </b-form-group>
      <b-form-group description label="شهر">
        <v-autocomplete
          v-model="newAccelerator.cityId"
          :items="
            iran
              .filter((x) => x.id == newAccelerator.stateId)
              .map((y) => y.cities)[0]
          "
          item-value="id"
          item-text="name"
          dense
          outlined
          class="dropdown-style"
          hide-details
        ></v-autocomplete>
      </b-form-group>
      <b-form-group label="آدرس">
        <b-form-input
          trim
          v-model="newAccelerator.address"
          type="text"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="توضیحات">
        <b-form-textarea
          id="textarea"
          v-model="newAccelerator.description"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      </b-form-group>
      <b-form-group label="موضوع فعالیت زیست فناوری">
        <v-autocomplete
          v-model="newCat"
          :items="categories"
          item-value="code"
          item-text="label"
          dense
          outlined
          class="dropdown-style"
          hide-details
        ></v-autocomplete>
      </b-form-group>
      <b-form-group label="محصولات">
        <b-row class="py-2">
          <b-col>
            <b-form-input
              trim
              v-model="newProduct"
              :no-wheel="true"
              placeholder="محصولات"
            ></b-form-input>
          </b-col>
          <b-col>
            <b-button
              variant="success"
              @click="addProduct()"
              style="float: right"
              :disabled="!newProduct"
              ><strong>افزودن محصول جدید +</strong></b-button
            >
          </b-col>
        </b-row>

        <b-table
          responsive
          show-empty
          head-variant="dark"
          :fields="productFields"
          :items="productItems"
          :current-page="productCurrentPage"
          :per-page="productPerPage"
          empty-text="هنوز محصولی ثبت نشده است"
          striped
        >
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 + productPerPage * (productCurrentPage - 1) }}
            </div>
          </template>
          <template v-slot:cell(operation)="data">
            <div
              style="
                text-align: center;
                vertical-align: middle;
                width: 150px;
                margin: auto;
              "
            >
              <b-button
                variant="danger"
                @click="productItems.splice(data.index, 1)"
                ><v-icon color="white">mdi-close-circle</v-icon></b-button
              >
            </div>
          </template>
          <div slot="table-busy" class="text-center text-danger my-2">
            <strong>در حال بارگذاری...</strong>
            <br />
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </b-table>
        <b-pagination
          v-model="productCurrentPage"
          :total-rows="productTotalRows"
          :per-page="productPerPage"
          first-text="ابتدا"
          prev-text="قبلی"
          next-text="بعدی"
          last-text="آخر"
          align="center"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-form-group>
      <!-- NOTE (b-addaccelerator) to add new accelerator -->
      <b-button
        :disabled="
          isBusy ||
          !newAccelerator.username ||
          !computedUsername ||
          !newAccelerator.name ||
          !newAccelerator.mobile ||
          !newAccelerator.registrationNumber ||
          !newAccelerator.nationalId ||
          !newAccelerator.stateId ||
          !checkUrl(newAccelerator.website) ||
          !validateEmail(newAccelerator.email)
        "
        variant="success"
        @click="addAccelerator()"
        >افزودن</b-button
      >
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import router from "../../router";
import utilities from "../../mixins/utilities";
import Select2 from "v-select2-component";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import validator from "validator";
import isURL from "validator/lib/isURL";
export default {
  components: {
    Select2,
    datePicker: VuePersianDatetimePicker,
    isURL,
    validator,
  },
  mixins: [utilities],

  data() {
    return {
      newAccelerator: {},
      acceleratorOtherInfo: {},
      logoPic: "",
      logoId: "",
      description: "",
      uploadPercentage: 0,
      isUploaded: false,
      file: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      changeLogo: false,
      iran: [],
      isBusy: false,
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      subjectRows: 1,
      productPerPage: 10,
      productCurrentPage: 1,
      productTotalRows: 1,
      filter1: "",
      isBusy1: true,
      subjectItems: [],
      filter2: "",
      isBusy2: true,
      states: [
        { value: "فعال", eng: "active", text: "فعال" },
        { value: "غیرفعال", eng: "deactive", text: "غیرفعال" },
      ],
      filter3: "",
      isBusy3: true,
      productFields: [
        { key: "index", label: "ترتیب" },
        { key: "title", label: "محصول" },
        { key: "operation", label: "عملیات" },
      ],
      productItems: [],

      newProduct: "",
      acceleratorId: "",
      fileBusy: false,
      selectedMehvar: "",
      addImage: false,
      uploading: false,
      categories: [],
      newCat: "",
    };
  },

  computed: {
    computedUsername() {
      if (!/^[a-zA-Z]+$/.test(this.newAccelerator.username)) {
        if (/^[0-9]+$/.test(this.newAccelerator.username)) {
          return false;
        } else {
          return true;
        }
      } else return true;
    },
  },

  methods: {
    checkUrl(url) {
      if (this.newAccelerator.website) {
        if (validator.isURL(url)) {
          return true;
        } else {
          return false;
        }
      } else return true;
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      // if (!event.currentTarget.classList.contains("bg-green-300")) {
      //   event.currentTarget.classList.remove("bg-gray-100");
      //   event.currentTarget.classList.add("bg-green-300");
      // }
    },
    dragleave(event) {
      // Clean up
      // event.currentTarget.classList.add("bg-gray-100");
      // event.currentTarget.classList.remove("bg-green-300");
    },
    drop(event) {
      event.preventDefault();
      this.file = event.dataTransfer.files;
      if (Array.from(this.file).length) {
        if (this.addImage) {
          if (Array.from(this.file).length > 1) {
            this.toast(
              " در این بخش شما مجاز به آپلود بیش از یک عکس نمی‌باشید.",
              "error"
            );
            return;
          }
        }
        Array.from(this.file).forEach((file) => {
          this.myUpload(file);
        });
      }
      // Clean up
      // event.currentTarget.classList.add("bg-gray-100");
      // event.currentTarget.classList.remove("bg-green-300");
    },
    myUpload(file) {
      // NOTE (m-myUpload) to upload files
      //this.changeLogo = false;
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 5 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else if (file.type != "image/jpeg" && file.type != "image/png") {
        this.toast("فرمت فایل مورد نظر مجاز نمی‌باشد. ", "error");
        return;
      } else {
        this.fileBusy = true;
        this.uploading = true;
        this.myFile.showProgress = true;
        this.myFile.variant = "info";
        this.myFile.uploadPercentage = 0;
        this.myFile.isUploaded = false;
        this.myFile.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl +
              "/setad/admin/accelerator/avatar?acceleratorId=" +
              this.acceleratorId,
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.myFile.uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((d) => {
            if (d.status == 200) {
              this.myFile.isUploaded = true;
              this.myFile.uploadPercentage = 100;
              this.myFile.striped = false;
              this.myFile.variant = "success";
              this.myFile.uploadButDisable = false;
              this.toast("تصویر با موفقیت افزوده شد", "success");
              setTimeout(() => {
                router.push("/admin/accelerators");
              }, 1000);
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.fileBusy = false;
          });
      }
    },
    justEng(str) {
      if (!/^[a-zA-Z0-9]+$/.test(str.key)) {
        str.key != "Backspace" && str.key != "Tab" ? str.preventDefault() : "";
      }
    },
    addAccelerator() {
      this.isBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/accelerator/new",
          {
            name: this.newAccelerator.name,
            username: this.newAccelerator.username,
            mobile: this.newAccelerator.mobile,
            tel: this.newAccelerator.tel,
            email: this.newAccelerator.email,
            stateId: this.newAccelerator.stateId ? this.newAccelerator.stateId : null,
            cityId: this.newAccelerator.cityId ? this.newAccelerator.cityId : null,
            registrationNumber: this.newAccelerator.registrationNumber,
            nationalId: this.newAccelerator.nationalId,
            economicCode: this.newAccelerator.economicCode,
            address: this.newAccelerator.address,
            website: this.newAccelerator.website,
            description: this.newAccelerator.description,
            ceoName: this.newAccelerator.ceoName,
            catId: this.newCat,
            products: this.productItems,
            isTrusted: this.newAccelerator.isTrusted,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast("شتاب‌دهنده با موفقیت ثبت شد.", "success");
          this.acceleratorId = res.data;
          this.changeLogo = true;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
          this.isBusy = false;
        });
    },
    getStatesAndCities() {
      this.$http
        .get(this.baseUrl + "/setad/options/states/list", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.iran = res.data;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    getCats() {
      this.$http
        .post(
          this.baseUrl + "/setad/options/cats/list",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.categories = [];
          this.categories.push(
            ...res.data.map((x) => {
              return {
                code: x.id,
                label: x.name,
              };
            })
          );
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    addProduct() {
      this.productItems.push({
        title: this.newProduct,
      });
      this.productTotalRows = this.productItems.length;
      this.newProduct = "";
    },
    notChangeLogo() {
      this.changeLogo = false;
      router.push("/admin/accelerators");
    },
  },

  mounted() {
    this.getStatesAndCities();
    this.getCats();
  },
};
</script>
<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style lang="scss">
.color {
  background-color: #0c4961;
  color: white;
}
.image-box {
  height: 100px;
  width: 90%;
  margin: auto;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  img {
    width: 100%;
    height: 100%;
  }
}
.profile-modalCard {
  border-radius: 10px !important;
  overflow: hidden !important;
  .image-box {
    height: 60vh;
    width: 75vh;
    max-width: 100%;
    max-height: 500px;
    min-width: 300px;
    margin: auto;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(61, 60, 60, 0.781);
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(46, 45, 45, 0.945);
    border-radius: 6px;
  }

  .cancel-btn {
    background-color: #6399e2 !important;
    color: #fff !important;
    box-shadow: none !important;
    width: 110px !important;
  }
  .cancel-btn {
    background-color: rgb(182, 39, 39) !important;
    color: #fff;
    box-shadow: none !important;
    width: 110px !important;
  }
  .change-btn {
    background-color: #6399e2 !important;
    color: #fff !important;
    box-shadow: none !important;
    width: 110px !important;
  }
}
.modal-card {
  .upload-box {
    padding: 20px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='9' ry='9' stroke='rgb(6, 141, 157)' stroke-width='2' stroke-dasharray='5' stroke-dashoffset='5' stroke-linecap='butt'/%3e%3c/svg%3e");
  }
  .file-icon {
    path {
      stroke: #068d9d;
    }
  }
}
.uploadPercentage {
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 70;
  padding: 10px;
  span {
    color: #93329e !important;
    margin: auto;
    font-size: 0.9rem;
  }
}
.v-text-field .v-input__slot,
.v-text-field fieldset {
  border-radius: 6px !important;
  border-color: #93329e !important;
}
.v-input__slot {
  min-height: 48px !important;
  margin-bottom: 25px;
  input {
    color: #656a81 !important;
  }
  .v-text-field__suffix {
    color: #656a81 !important;
  }
}

label.v-label.v-label--active.theme--light {
  font-size: 0.9rem !important;
  color: #93329e !important;
  background-color: #fff;
  padding: 1px 10px;
  margin-bottom: 0 !important;
  height: 25px;
  transform: translateY(-31px);
}
.v-input__icon--prepend button {
  color: #93329e !important;
}

/* pass validation style */
.pass {
  font-size: 13px;
}
.pass--passed {
  color: #717b85;
}
.frmIcon {
  color: #eb0029;
}
.pass--passed .frmIcon {
  color: #0fa140;
}
.required {
  color: red;
}

.done {
  color: green;
}
</style>
